<template>
  <div :class="'col-' + documentSize" style="display:inline-block">
    <!-- <i class="fa fa-caret-left"></i> -->
    <div>
      <div @click="switchFocusDoc" :class="{focusedDoc: focusDoc}">
        <pdf v-if="documentType === 'pdf' && documentDataForPDF.data" ref="pdf"
          :src="documentDataForPDF"
          :page="page" @progress="loadedRatio = $event"
          @numPages="numPages = $event">
        </pdf>
        <img v-else :src="src" style="width:100%;">
        </img>
      </div>
      <span style="display:inline-block;text-align:center;width:100%;">
        {{page + '/' + numPages}}
      </span>
    </div>
    <!-- <i class="fa fa-caret-right"></i> -->
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'DocumentViewer',
  props: {
    initSize: {
      type: Number,
      default: 3
    },
    page: {
      type: Number,
      default: 1
    },
    src: {
      type: String,
      default: ''
    }
  },
  components: {
    pdf
  },
  data () {
    return {
      documentDataForPDF: {},
      documentSize: 3,
      documentType: '',
      focusDoc: false,
      loadedRatio: 0,
      numPages: 1,
      rotate: 0
    }
  },
  created () {
    this.docSize = this.initSize

    let fileHeader = this.src.split(',')[0]
    if (fileHeader === 'data:application/pdf;base64') {
      this.documentType = 'pdf'
      let binaryVersionOfThePdf = window.atob(this.src.split(',')[1])
      this.documentDataForPDF = {
        data: binaryVersionOfThePdf
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.changePage)
  },
  methods: {
    changePage (event) {
      event.preventDefault()
      switch (event.which) {
        case 37:
          if (this.page > 1) {
            this.page--
          }
          break
        case 38:
          if (this.documentSize < 12) {
            this.documentSize++
          }
          break
        case 39:
          if (this.page < this.numPages) {
            this.page++
          }
          break
        case 40:
          if (this.documentSize > 1) {
            this.documentSize--
          }
          break
        default:
          break
      }
    },
    switchFocusDoc () {
      if (this.focusDoc) {
        window.removeEventListener('keydown', this.changePage)
      } else {
        window.addEventListener('keydown', this.changePage)
      }
      this.focusDoc = !this.focusDoc
    }
  }
}
</script>
<style scoped>
.focusedDoc {
  border: 5px solid cyan;
}
</style>



// WEBPACK FOOTER //
// DocumentViewer.vue?b5c23ab2